import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {Timeline, TimelineLite, TweenLite} from "gsap";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {BetLineEvent} from "@nolimitcity/slot-game/bin/core/betline/event/BetLineEvent";
import {IBetLineWinData, IBetWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {BetLineWin} from "@nolimitcity/slot-game/bin/timelinegameround/game/gameround/presentations/BetLineWin";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ImmortalFruitsGameConfig} from "../../ImmortalFruitsGameConfig";
import {ImmortalFruitsGameModuleConfig} from "../../ImmortalFruitsGameModuleConfig";
import {SymbolUtil} from "../../utils/SymbolUtil";
import {StateMatrix} from "../../utils/StateMatrix";
import {ForegroundAnimation} from "../../foregroundanimation/ForegroundAnimation";
import {bigWinEvents} from "../../views/WinTextView";
import {ImmortalFruitsGameMode} from "../../ImmortalFruitsGameMode";
import {ImmortalFruitsBetlineEvent} from "../../betline/ImmortalFruitsBetlineEvent";
import {ImmortalFruitsParsedInitData} from "../../server/data/ImmortalFruitsParsedInitData";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {SoundManager} from "../../resource/sound/SoundManager";
import {ImmortalFruitsSoundConfig} from "../../ImmortalFruitsSoundConfig";
import {ImmortalFruitsParsedGameData} from "../../server/data/ImmortalFruitsParsedGameData";

export class ImmortalFruitsBetLineWin extends BetLineWin {
    private _forInitialWin: boolean = false;
    private _sequenceBetLineCouter: number = 0.35;
    private sequenceBetLineCouterArr: number[] = [];
    private _sumOfBetLinesCounter: number = 0;
    private currentBetline: number = 0;
    private _symbolStates:StateMatrix<string>;
    private count100for:number=0;
    private countBetLine:number=0;
    private setTimeOutArr:any[]=[];

    /**
     * @constructs
     */
    constructor(forInitialWin: boolean = false) {
        super();

        this._forInitialWin = forInitialWin;
    }


    /**
     * @inheritDoc
     * @param data
     */
    public getAnimation(data: ParsedGameData | ImmortalFruitsParsedInitData): Timeline | null {
        if(data instanceof ParsedGameData){
            if(data!.currentWinRatioConfig==undefined){
                return null
                /*209*/
            }
        }

        if (data==null || data.betWins === undefined || data.betWins.length <= 0 ||((!(data as ImmortalFruitsParsedInitData).isRestoreState) && (data as ImmortalFruitsParsedGameData).gambleOptionPicked!==-1)) {
            return null;
            /*209*/
        }
        this._symbolStates = SymbolUtil.createSymbolStateMatrixFromBetWins(
            <IBetLineWinData[]>data!.betWins!,
            ImmortalFruitsGameConfig.instance.SYMBOL_STATES.noWin!.keyword,
            ImmortalFruitsGameConfig.instance.SYMBOL_STATES.win!.keyword);
        const tl: TimelineLite = new TimelineLite();
        let noWinAnimations: TimelineLite;
        !this._forInitialWin && EventHandler.dispatchEvent(new GameEvent(BetLineEvent.HIDE_ALL_BET_LINES));
            this.sequenceBetLineCouterArr.length =0;
            this._sumOfBetLinesCounter=0;
            this._sequenceBetLineCouter=0.4;
            this.currentBetline = 0;
            if(this.setTimeOutArr.length>0){
                for(let k=0; k<this.setTimeOutArr.length;k++){
                    clearTimeout(this.setTimeOutArr[k]);
                }
            }
        // adding no win sym animation with restore in gamble mode.
        if ((data as ImmortalFruitsParsedInitData).isRestoreState && data.nextMode === ImmortalFruitsGameMode.GAMBLE) {
            noWinAnimations = this.getNoWinSymbolAnimations(data);
        } else {
            noWinAnimations = new TimelineLite();
        }
        const winAnimations: TimelineLite = this.getWinAnimationsImm(data);

        tl.add([
            noWinAnimations,
            winAnimations,
        ]);
        tl.delay(0.15)





        return tl;
    }
    /**
     * @description This method will set the no win state.
     */
    private getNoWinSymbolAnimations(data:ParsedGameData|ParsedInitData): TimelineLite {
        const tl: TimelineLite = new TimelineLite();

        tl.add(() => {
            for (let reelId = 0; reelId < ImmortalFruitsGameConfig.instance.REELS_NUM; reelId++) {
                const reelCoords: [number, number][] = this._symbolStates.getCoordinatesWithStateInReel(reelId, ImmortalFruitsGameConfig.instance.SYMBOL_STATES.noWin!.keyword);
                for (let coords of reelCoords) {
                    let sym =Reels.getSymbol(coords[0], coords[1])!;
                    if(!(sym!.symName=="S" && data && data!.nextMode && (data!.nextMode===ImmortalFruitsGameMode.BONUS_WHEEL||(data!.nextReelSetName && data!.nextReelSetName === "BONUS_REELSET")))) {

                        sym!.changeState({
                            state: ImmortalFruitsGameConfig.instance.SYMBOL_STATES.noWin!,
                            setStack: true,
                            fadeInDuration: 0.0
                        })!;
                    }
                }
            }
        }, 0);

        return tl;
    }

    /**
     * @description Need this method to play symbol animations.
     * @param reelId
     * @param symbolId
     * @param state
     */
    protected getSymbolAnimationBOS(reelId: number, symbolId: number, state: ISymbolStateConfig): TimelineLite {

        const tl: TimelineLite = new TimelineLite();
        const symbol: StateReelSymbol | null = Reels.getSymbol(reelId, symbolId);
        if (symbol) {
            // difference from parent method is here.
            const symbolAnimation: Timeline = ImmortalFruitsGameModuleConfig.symWinAnims.playAnimation(reelId, symbolId, symbol);

            tl.add([
                () => ImmortalFruitsBetLineWin.sortSymbolDepthToTopBOS(symbol),
                symbolAnimation,
                ForegroundAnimation!.getSymbolAnimShow(reelId, symbolId),
            ]);
        }
        return tl;
    }

    /**
     * @inheritDoc => similar method is in parent class
     * @param data
     */
    private getWinAnimationsImm(data: ParsedGameData | ImmortalFruitsParsedInitData): TimelineLite {

        const tl: TimelineLite = new TimelineLite({onComplete:()=>{

            }});
        let sumOfBetlineAmt =0;
        let toValue =0;
        let noOfBetlinesTobeShownOneByOne =0;
        if(data instanceof ParsedGameData){
             toValue = data.playedBetValue * ImmortalFruitsGameConfig.instance.WIN_RATIOS.bigWin[0].ratio;
        }
        this.calcBetlineTimeForBonusGame(data!.betWins!.length);
        for (let i: number = 0; i < data.betWins!.length; i++) {
            sumOfBetlineAmt += data!.betWins![i]!.amount;

            if(data.betWins!.length <= 5){
                noOfBetlinesTobeShownOneByOne = data.betWins!.length;
            }
            if( data.betWins!.length > 5 && data.betWins!.length <=10)  {
                noOfBetlinesTobeShownOneByOne = 8;
            }
            if( data.betWins!.length > 11 && data.betWins!.length <=25)  {
                noOfBetlinesTobeShownOneByOne =16;
            }
            if( data.betWins!.length > 25)  {
                noOfBetlinesTobeShownOneByOne =26;
            }

            this.countBetLine =0;

            if (this._forInitialWin) {
                i>0 && this.betlineTimeForBonusGame(data!.betWins!.length,i);
                if(i<noOfBetlinesTobeShownOneByOne) {
                    tl.add(() => {
                        let betLineWinData = <IBetLineWinData>data.betWins![i];
                        if (!ImmortalFruitsGameConfig.instance.WIN_BELOW_STAKE) { // #305
                            SoundManager.playSound(ImmortalFruitsSoundConfig.instance.BETLINE_SOUND);
                        }
                        EventHandler.dispatchEvent(new GameEvent(BetLineEvent.SHOW_WIN_BET_LINE, (betLineWinData!.betLineIndex + 1)));
                        this.currentBetline = betLineWinData!.betLineIndex + 1;
                    }, this.sequenceBetLineCouterArr[i]);
                    if(noOfBetlinesTobeShownOneByOne<=5 && i==noOfBetlinesTobeShownOneByOne-1) {
                        tl.add(() => {

                        }, this.sequenceBetLineCouterArr[i]+0.2);
                    }
                }
                //#306
                if(i>=noOfBetlinesTobeShownOneByOne){
                    tl.add(()=>{
                        if(i==data.betWins!.length-1){
                            EventHandler.dispatchEvent(new GameEvent(bigWinEvents.STOP_GREENLIGHTS ));
                            EventHandler.dispatchEvent(new GameEvent(bigWinEvents.STOP_BIGWIN ));
                        }
                        let betLineWinData = <IBetLineWinData>data.betWins![i];
                        this.countBetLine ++;
                        if (this.countBetLine == 1 && !ImmortalFruitsGameConfig.instance.WIN_BELOW_STAKE) { // #305
                            SoundManager.playSound(ImmortalFruitsSoundConfig.instance.BETLINE_SOUND);
                        }
                        this.setTimeOutArr.push(setTimeout(()=>{
                            EventHandler.dispatchEvent(new GameEvent(BetLineEvent.SHOW_WIN_BET_LINE, (betLineWinData!.betLineIndex + 1)));
                       },this.sequenceBetLineCouterArr[i]));

                    },this.sequenceBetLineCouterArr[noOfBetlinesTobeShownOneByOne]);
                }
            }else{
                    tl.add([
                       this.getLineAnimationBOS(<IBetLineWinData>data.betWins![i],data.betWins!.length),
                        () => EventHandler.dispatchEvent(new GameEvent(BetLineEvent.SHOW_WIN_BET_LINE, (<IBetLineWinData>data.betWins![i]).betLineIndex + 1)),
                        ()=>EventHandler.dispatchEvent(new GameEvent(ImmortalFruitsBetlineEvent.SHOW_WIN_BET_AMOUNT, {"betlineIndx":(<IBetLineWinData>data.betWins![i]).betLineIndex + 1,"betwins":data.betWins!})),

                    ]);

            }

        }


        return tl;
    }


    /**
     * @description Controlling the animation time and hiding the betLine from this method.
     * @param betLineWinData
     * @param length
     * @param tl
     */
    private getLineAnimationBOS(betLineWinData: IBetLineWinData, length: number):TimelineLite {

        const tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            for (let reelId: number = 0; reelId < betLineWinData.nrOfSymbols; reelId++) {
                ForegroundAnimation.resetStaticBgShow();
                this.getSymbolAnimationBOS(reelId, betLineWinData.betLine[reelId], ImmortalFruitsGameConfig.instance.SYMBOL_STATES.win);
            }
            this.currentBetline = betLineWinData!.betLineIndex + 1;
        });
        // // need to add this empty tween so that the symbol animation play full for its time.
        tl.add(new TweenLite(() => {}, 0.5, {}), 0);
        // need to add this empty tween so that the symbol set back to its normal state between the toggling.
        tl.add(new TweenLite(() => {}, 0.1, {}), 1);

        if (!this._forInitialWin) {
            tl.add(() => {
                EventHandler.dispatchEvent(new GameEvent(BetLineEvent.HIDE_WIN_BET_LINE, betLineWinData.betLineIndex + 1));
            },1);
        }
        return tl;
    }
    private betlineTimeForBonusGame(betlineLength:number,index:number): number {
        if(betlineLength <= 5) {
           // this._sumOfBetLinesCounter=0.2;
            this._sequenceBetLineCouter = 0.2;
        }
        if( betlineLength > 5 && betlineLength <= 10) {
            //this._sumOfBetLinesCounter=0.4;
            if (this._sequenceBetLineCouter > 0.1) {
                this._sequenceBetLineCouter = Math.round((this._sequenceBetLineCouter - 0.05) * 100) / 100;
                if( this._sequenceBetLineCouter==0.35){
                    this.betlineTimeForBonusGame(betlineLength,index);
                    return this._sumOfBetLinesCounter
                }

            }
            //console.log("print _sequenceBetLineCouter", this._sequenceBetLineCouter);
        }
        if( betlineLength > 11) {
            //this._sumOfBetLinesCounter=0.4;

            if (this._sequenceBetLineCouter > 0.1) {
                this._sequenceBetLineCouter = Math.round((this._sequenceBetLineCouter - 0.05) * 100) / 100;
                if( this._sequenceBetLineCouter==0.35){
                    this.betlineTimeForBonusGame(betlineLength,index);
                    return this._sumOfBetLinesCounter
                }
            }else{
                if(this.count100for<3) {
                    this.count100for++;
                }else{
                    if (this._sequenceBetLineCouter > 0.05) {
                        this._sequenceBetLineCouter = Math.round((this._sequenceBetLineCouter - 0.01) * 100) / 100
                    }
                }
            }
        }
        this._sumOfBetLinesCounter += this._sequenceBetLineCouter;
        this.sequenceBetLineCouterArr.push(this._sumOfBetLinesCounter);
        return this._sumOfBetLinesCounter;
    }
    private calcBetlineTimeForBonusGame(betlineLength:number):any{
        this.count100for =0;
       if(betlineLength <= 5){
           this._sequenceBetLineCouter = 0.2;
           this._sumOfBetLinesCounter=0.2;
       }
        if( betlineLength > 5) {
            this._sequenceBetLineCouter=0.4;
            this._sumOfBetLinesCounter=0.4;
        }
        this.sequenceBetLineCouterArr.push(this._sumOfBetLinesCounter);
    }
    /**
     * @inheritDoc
     * @param isActive
     * @param data
     */
    public abort(isActive: boolean, data: ParsedGameData): gsap.TimelineLite {
        const tl = new TimelineLite();
        tl.add(()=>{
            if(data && data.betWins.length>0)
            data.betWins!.forEach((data:IBetWinData) => {
               // console.log("data abort",data)
                EventHandler.dispatchEvent(new GameEvent(BetLineEvent.SHOW_WIN_BET_LINE, ((<IBetLineWinData>data).betLineIndex)+1));
            });

        });
        EventHandler.dispatchEvent(new GameEvent(bigWinEvents.STOP_GREENLIGHTS ));
        EventHandler.dispatchEvent(new GameEvent(bigWinEvents.STOP_BIGWIN ));
        return tl;
    }


    /**
     * @inheritDoc => similar method is in parent class
     * @param symbol
     */
    private static sortSymbolDepthToTopBOS(symbol:StateReelSymbol):void {
        if(symbol && symbol.parent) {
            symbol.parent.addChild(symbol);
        }
    }

}